import { z } from "zod";

import type { ModuleLoadError } from "./types";

const moduleLoadErrorBaseSchema = z.object({
  moduleId: z.string(),
  version: z.string(),
  cdnUrl: z.string(),
});

export const moduleLoadErrorSchema = z.discriminatedUnion("code", [
  moduleLoadErrorBaseSchema.extend({
    code: z.literal("NETWORK_ERROR"),
    cause: z.instanceof(Error),
  }),
  moduleLoadErrorBaseSchema.extend({
    code: z.literal("INVALID_MODULE"),
    reason: z.string(),
  }),
  moduleLoadErrorBaseSchema.extend({
    code: z.literal("IMPORT_ERROR"),
    cause: z.instanceof(Error),
  }),
]);

export function isModuleLoadError(value: unknown): value is ModuleLoadError {
  return moduleLoadErrorSchema.safeParse(value).success;
}
